export default __webpack_public_path__ + "static/media/reportnet-3.0-logo-dark-mode.090a419e.png";